import Backbone from 'backbone';
import BackboneDeepModel from '@kahwee/backbone-deep-model';
import Utils from '../utils';
import Errors from './../../base/errors.js';
import { requestUrls } from './../../../base/vars.js';
import PhoneInput from '../../components/phone-input';

export default BackboneDeepModel.extend({
  url: requestUrls.memberSearch,

  defaults: {
    firstTimeSignIn: true,
    highBalance: false,
    resetPwEmailSent: false,
    resetPwEmailSentTo: 'xxx@example.com'
  },

  initialize() {
    this.on('error', (model, xhr, options) => {
      this.error(model, xhr, options);
    });
  },

  validation: {
    memberNumber: {
      required: (value, attr, state) => {
        return state.firstTimeSignIn || !state.email;
      },
      memberNumberValidation: true
    },
    email: {
      required: (value, attr, state) => {
        if (state.firstTimeSignIn) {
          return !state.phone;
        }
        return !state.memberNumber;
      },
      pattern: 'email'
    },
    phone: {
      required: (value, attr, state) => {
        return state.firstTimeSignIn && !state.email;
      },
      phoneNumberValidation: true
    },
    lastName: {
      required: (value, attr, state) => {
        return !state.firstTimeSignIn;
      }
    },
    zipCode: {
      required: (value, attr, state) => {
        return !state.city;
      }
    },
    city: {
      required: (value, attr, state) => {
        return !state.zipCode;
      }
    }
  },

  validate(attrs, options) {},

  getData(flow) {
    let data = {};

    if (this.get('memberNumber')) {
      data.memberNumber = this.get('memberNumber');
    }

    if (this.get('firstTimeSignIn')) {
      data.flow = 'firsttime';

      let email = this.get('email');
      if (email) {
        data.email = email;
      } else {
        const updatedPhonNumber = PhoneInput.getPhoneNumberWithCountryCode(this.get('phone'), 0);
        data.phoneNumber = updatedPhonNumber;
      }
    } else {
      data.flow = '';
      data.lastName = this.get('lastName');

      if (!data.memberNumber) {
        data.email = this.get('email');
      }
    }

    let zip = this.get('zipCode');
    if (zip) {
      data.zipCode = zip;
    } else {
      data.city = this.get('city');
    }

    return data;
  },

  save(attrs, options) {
    let requestData = this.getData();

    const memberSearchData = {
      'memberIdentifier': requestData.memberNumber,
      'email': requestData.email || '',
      'phoneNumber': requestData.phoneNumber || '',
      'zipCode': requestData.zipCode || '',
      'city': requestData.city || ''
    };

    options = _.extend({
      type: 'POST',
      url: this.url,
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(memberSearchData)
    },
    options
    );

    return Backbone.DeepModel.prototype.save.call(this, attrs, options);
  },

  parse(response, options) {
    if (!this.get('firstTimeSignIn')) {
      Utils.extendUserData(JSON.parse(options.data));
    }
    Utils.extendUserData(response.data);
    if (response.data.resetPwEmailSent) {
      response.data.highBalance = true;
    }
    return response.data;
  },

  error(model, xhr, options) {
    Errors.handleResponse(null, xhr, options);
  }
});
